import { Fieldset as BaseFieldset } from "@base-ui-components/react/fieldset";
import { ComponentProps } from "react";
import {
  fieldSetColumnsClasses,
  fieldSetLegendClasses,
  fieldSetRootClasses,
} from "./Fieldset.style";

type FieldsetProps = BaseFieldset.Root.Props & {
  label?: string;
  columns?: 1 | 2 | 3 | 4 | 5 | 6;
};
const Fieldset = (props: FieldsetProps) => {
  const { label, children, columns = 1, className, ...rest } = props;

  return (
    <BaseFieldset.Root
      {...rest}
      className={fieldSetRootClasses({
        columns,
        className: typeof className === "string" ? className : "",
      })}
    >
      {label && (
        <BaseFieldset.Legend className={fieldSetLegendClasses()}>
          {label}
        </BaseFieldset.Legend>
      )}

      {/* Your fields here */}
      {columns > 1 ? (
        <div className={fieldSetColumnsClasses({ columns })}>{children}</div>
      ) : (
        children
      )}
    </BaseFieldset.Root>
  );
};

export default Fieldset;
